import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { ASSESSMENT_TYPES } from 'modules/Assessments/actions'
import { useDispatch } from 'react-redux'

const Container = styled.div`
  width: 1258px;
  height: 545px;
  position: relative;
  top: 80px;
  left: 120px;
  padding: 15px 25px 30px 25px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`

const Title = styled.h1`
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  margin: 0;
`

export const AssessmentTimer = styled.div`
  padding: 12px 24px;
  background: ${props => props.timeLeft < 120 ? '#fff1f1' : '#e8fff3'};
  border-radius: 8px;
  color: ${props => props.timeLeft < 120 ? '#e53e3e' : '#111827'};
  font-size: 16px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border: 1px solid ${props => props.timeLeft < 120 ? '#e53e3e' : '#5db594'};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`

const AssessmentName = styled.div`
  color: #666666;
  font-size: 14px;
  margin-bottom: 40px;
`

const ThankYouText = styled.h2`
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 16px;
`

const Message = styled.p`
  font-size: 14px;
  color: #666666;
  margin: 0;
`

const NextButton = styled.button`
  position: absolute;
  bottom: 30px;
  left: 25px;
  padding: 8px 24px;
  background: #4640de;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background: #3530ca;
  }
`

const Completion = ({ assessmentData, submittedTime }) => {
  const navigate = useNavigate()
  const [remainingTime, setRemainingTime] = useState(30 * 60) // 30 minutes in seconds
  const dispatch = useDispatch()
  useEffect(() => {
    const timer = setInterval(() => {
      setRemainingTime(prevTime => {
        if (prevTime <= 0) {
          clearInterval(timer)
          return 0
        }
        return prevTime - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  const formatTime = seconds => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds
      .toString()
      .padStart(2, '0')}`
  }

  const handleNext = () => {
    dispatch({
      type: ASSESSMENT_TYPES.SUBMIT_ASSESSMENT_SUCCESS,
    })
    navigate('/')
  }

  return (
    <Container>
      <Header>
        <Title>{assessmentData?.title || 'Behavioral Assessment'}</Title>
        <AssessmentTimer timeLeft={submittedTime}>
          Timer : {formatTime(submittedTime)}
        </AssessmentTimer>
      </Header>
      <AssessmentName>
        Assessment Name : {assessmentData?.type || 'Behavioral Assessment'}
      </AssessmentName>
      <ThankYouText>Thank you for attending the assessment!</ThankYouText>
      <Message>
        Your result is being processed and will be available shortly. Please
        check the "Completed Assessment" tab to view your score
      </Message>
      <NextButton onClick={handleNext}>Next</NextButton>
    </Container>
  )
}

export default Completion
